import { DebitNoteResponse } from '@/app/models/debitNote';
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  fontWeight: 'bold',
}));

const RowTableCell = styled(TableCell)(() => ({
  fontSize: 13,
}));

type DebitNoteTableProps = {
  rows: DebitNoteResponse[];
  count: number;
  rowsPerPage: number;
  setRowsPerPage: (n: number) => void;
  page: number;
  setPage: (n: number) => void;
};

const formatter = new Intl.NumberFormat('pt-BR');
const formatterMonetaryValue = (value: any) => `${formatter.format(value)}`;

export default function DebitNoteTable(props: DebitNoteTableProps) {
  const { t } = useTranslation(['debitNote', 'common']);
  const { rows, count, rowsPerPage, setRowsPerPage, page, setPage } = props;

  return (
    <div>
      <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
        <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead>
            <TableRow>
              <HeaderTableCell>{t('branch')}</HeaderTableCell>
              <HeaderTableCell>{t('account.code')}</HeaderTableCell>
              <HeaderTableCell>{t('credit.project.code')}</HeaderTableCell>
              <HeaderTableCell>{t('debit.project.code')}</HeaderTableCell>
              <HeaderTableCell>{t('common:value')}</HeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <RowTableCell>{row.branch}</RowTableCell>
                <RowTableCell>{row.accountCode}</RowTableCell>
                <RowTableCell>{row.creditProjectCode}</RowTableCell>
                <RowTableCell>{row.debitProjectCode}</RowTableCell>
                <RowTableCell>{`R$ ${formatterMonetaryValue(row.value)}`}</RowTableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell sx={{ textAlign: 'center' }} colSpan={5}>
                  <Typography variant="subtitle2">
                    {t('common:no.data.for.the.chosen.period.and.search.term')}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          sx={{ width: '100%' }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={count || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, p) => setPage(p)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          labelDisplayedRows={({ from, to, count: tcount }) => `${from}-${to} ${t('de')} ${tcount}`}
          labelRowsPerPage={t('common:items.per.page')}
        />
      </TableContainer>
    </div>
  );
}
